// extracted by css-extract-rspack-plugin
export default {"Text":"Description-module__Text__srd2u","Box":"Description-module__Box__RFs2C"};